import styles from './Spacer.module.css';
import { cva, type VariantProps } from 'class-variance-authority';

export const spacerVariants = cva(styles.spacer, {
  variants: {
    w: {
      none: styles['w-0'],
      0: styles['w-0'],
      '5xs': styles['w-5xs'],
      '4xs': styles['w-4xs'],
      '3xs': styles['w-3xs'],
      '2xs': styles['w-2xs'],
      xs: styles['w-xs'],
      sm: styles['w-sm'],
      md: styles['w-md'],
      lg: styles['w-lg'],
      xl: styles['w-xl'],
      '2xl': styles['w-2xl'],
      '3xl': styles['w-3xl'],
      '4xl': styles['w-4xl'],
      '5xl': styles['w-5xl'],
    },
    h: {
      none: styles['h-0'],
      0: styles['h-0'],
      '5xs': styles['h-5xs'],
      '4xs': styles['h-4xs'],
      '3xs': styles['h-3xs'],
      '2xs': styles['h-2xs'],
      xs: styles['h-xs'],
      sm: styles['h-sm'],
      md: styles['h-md'],
      lg: styles['h-lg'],
      xl: styles['h-xl'],
      '2xl': styles['h-2xl'],
      '3xl': styles['h-3xl'],
      '4xl': styles['h-4xl'],
      '5xl': styles['h-5xl'],
    },
    inline: {
      true: styles.spacerInline,
    },
  },
  defaultVariants: {
    h: 'sm',
    w: 'sm',
  },
});

export type SpacerVariants = VariantProps<typeof spacerVariants>;

export interface SpacerProps extends SpacerVariants {
  /**
   * Spacer becomes visible in the UI for debugging purposes
   */
  debugVisible?: boolean;
  /**
   * Test ID for the component, used for testing purposes
   */
  'data-testid'?: string;
}

export const Spacer = ({
  debugVisible,
  'data-testid': dataTestId,
  ...props
}: SpacerProps) => {
  return (
    <span
      className={`${spacerVariants(props)} ${
        debugVisible ? styles.debugVisible : ''
      }`}
      aria-hidden="true"
      role="presentation"
      data-testid={dataTestId}
    />
  );
};

export default Spacer;
